// extracted by mini-css-extract-plugin
export default {"Menu":"Menu_Menu__kwDyd","container":"Menu_container__4cClB","item":"Menu_item__-YcIx"};